import { Body, Controller, Delete, Get, Param, Patch, Post, UseGuards } from '@nestjs/common';
import { AuthGuard } from '@nestjs/passport';
import { ApiBearerAuth, ApiOperation, ApiTags } from '@nestjs/swagger';
import type { LoginUserInfo } from 'src/auth/dto/login.dto';
import { RequirePermission } from 'src/auth/decorators/require-permission.decorator';
import { GetUser } from 'src/auth/get-user.decorator';
import { PermissionGuard } from 'src/auth/guards/permission.guard';
import { CentrosCostoService } from '../services/centros-costo.service';

@ApiTags('Contabilidad - Centros de Costo')
@Controller({ path: 'contabilidad/centros-costo', version: '1' })
@UseGuards(AuthGuard('jwt'), PermissionGuard)
@ApiBearerAuth()
export class CentrosCostoController {
  constructor(private readonly service: CentrosCostoService) {}

  @Get()
  @RequirePermission('CONTABILIDAD', 'CONT_CC_CENTRO_COSTO_VER')
  @ApiOperation({ summary: 'Listar centros de costo' })
  listar(@GetUser() user: LoginUserInfo) {
    return this.service.listar(user.empresa_id);
  }

  @Post()
  @RequirePermission('CONTABILIDAD', 'CONT_CC_CENTRO_COSTO_CREAR')
  @ApiOperation({ summary: 'Crear centro de costo' })
  crear(@GetUser() user: LoginUserInfo, @Body() body: { codigo: string; descripcion: string }) {
    return this.service.crear(user.empresa_id, body);
  }

  @Patch(':id')
  @RequirePermission('CONTABILIDAD', 'CONT_CC_CENTRO_COSTO_EDITAR')
  @ApiOperation({ summary: 'Editar centro de costo' })
  editar(
    @Param('id') id: string,
    @GetUser() user: LoginUserInfo,
    @Body() body: Partial<{ descripcion: string; activo: boolean }>,
  ) {
    return this.service.editar(id, user.empresa_id, body);
  }

  @Delete(':id')
  @RequirePermission('CONTABILIDAD', 'CONT_CC_CENTRO_COSTO_ELIMINAR')
  @ApiOperation({ summary: 'Eliminar centro de costo (solo sin movimientos)' })
  eliminar(@Param('id') id: string, @GetUser() user: LoginUserInfo) {
    return this.service.eliminar(id, user.empresa_id);
  }
}
